import { handleActions } from 'redux-actions'
import update from 'immutability-helper'

import {
  REQUEST_EVENT,
  RECEIVE_EVENT,
  CREATE_EVENT,
  EDIT_EVENT,
  DELETE_EVENT,
  DELETE_EVENT_STAGE
} from '../actions/event'

import {
  UPDATE_EVENT_STAGE,
  CREATE_EVENT_STAGE
} from '../actions/event-stage'

import {
  CREATE_EVENT_USER,
  DELETE_EVENT_USER
} from '../actions/event-user'

import {
  CREATE_RIDER_REQUEST,
  FULFILL_RIDER_REQUEST,
  DELETE_RIDER_REQUEST
} from '../actions/event-rider-request'

const finishSaving = (state) => update(state, {isSaving: {$set: false}})

const errorHandler = (action_payload) => {
  const { data } = action_payload

  if (data.status === 'error') {
    return {
      error: {
        code: action_payload.status,
        message: data.message
      }
    }
  }
}

export default handleActions({
  [REQUEST_EVENT]: (state, action) => ({isFetching: true}),
  [RECEIVE_EVENT]: (state, action) => {
    const error = errorHandler(action.payload)
    if (error) return error

    const { event } = action.payload.data

    state = update(state, {$set: event})

    return state
  },
  [CREATE_EVENT]: (state, action) => {
    const { id } = action.payload.data

    state = update(state, {$set: {createdEventId: id}})

    return state
  },
  [EDIT_EVENT]: (state, action) => {
    const { event } = action.payload.data

    state = update(state, {$set: event})

    return state
  },
  [DELETE_EVENT]: (state, action) => {
    const { id } = action.payload.data

    state = update(state, {
      deletedEventId: {$set: id}
    })

    return state
  },
  [UPDATE_EVENT_STAGE]: (state, action) => {
    return update(state, {
      isSaving: {$set: true}
    })
  },
  [CREATE_EVENT_STAGE]: (state, action) => {
    const { event, stage } = action.payload.data

    state = update(state, {$set: event})
    state = update(state, {createdStageId: {$set: stage.id}})

    return finishSaving(state)
  },
  [DELETE_EVENT_STAGE]: (state, action) => {
    const { id, event } = action.payload.data

    state = update(state, {$set: event})
    state = update(state, {deletedStageId: {$set: {id}}})

    return state
  },
  [CREATE_EVENT_USER]: (state, action) => {
    const { event } = action.payload.data

    state = update(state, {$set: event})

    return finishSaving(state)
  },
  [DELETE_EVENT_USER]: (state, action) => {
    const { event } = action.payload.data

    state = update(state, {$set: event})

    return finishSaving(state)
  },
  [CREATE_RIDER_REQUEST]: (state, action) => {
    const { event } = action.payload.data

    state = update(state, {$set: event})

    return state
  },
  [FULFILL_RIDER_REQUEST]: (state, action) => {
    const { event } = action.payload.data

    state = update(state, {$set: {createdEventId: event.id}})

    return state
  },
  [DELETE_RIDER_REQUEST]: (state, action) => {
    const { event } = action.payload.data

    state = update(state, {$set: event})

    return state
  }
}, {})



// WEBPACK FOOTER //
// ./src/reducers/event.js